const read = (storage, key) => storage?.getItem?.(key) || '';

export function beginStoredSession(storage, userId) {
  const normalizedUserId = String(userId || '').trim();
  if (!normalizedUserId) return '';

  const previousUserId = read(storage, 'authUid');
  if (previousUserId !== normalizedUserId) {
    storage.removeItem('userRole');
  }
  storage.setItem('authUid', normalizedUserId);

  return previousUserId === normalizedUserId
    ? read(storage, 'userRole')
    : '';
}

export function getStoredRoleForUser(storage, userId, acceptedRoles = []) {
  const normalizedUserId = String(userId || '').trim();
  if (!normalizedUserId || read(storage, 'authUid') !== normalizedUserId) return '';

  const role = read(storage, 'userRole');
  if (!role) return '';
  if (acceptedRoles.length && !acceptedRoles.includes(role)) return '';
  return role;
}

export function saveStoredRole(storage, userId, role) {
  const normalizedUserId = String(userId || '').trim();
  const normalizedRole = String(role || '').trim();
  if (!normalizedUserId || !normalizedRole) return;

  storage.setItem('authUid', normalizedUserId);
  storage.setItem('userRole', normalizedRole);
}

export function clearStoredSession(storage) {
  storage.removeItem('userRole');
  storage.removeItem('authUid');
}
